const { Fragment, useEffect, useState } = wp.element;

import Settings from "./settings";

import H5AP from "./../../js/player/single";
import Style from "./Style";
// import BPLSDK from "./../../../bplugins_sdk/src/components/v1/BPLSDK";

const H5AP_Obj = new H5AP();
const Edit = (props) => {
  const { attributes, setAttributes, clientId } = props;
  const [isPremium] = useState(window.h5apPlayer?.isPipe);
  setAttributes({ clientId });
  const { uniqueId, source, color, bgColor, align, primaryColor, controls, download, poster, skin, title, artist, repeat, seekTime } = attributes;

  useEffect(() => {
    setAttributes({ uniqueId: "h5ap" + clientId.substr(0, 8) });
  }, []);

  useEffect(() => {
    const audioPlayer = document.querySelector(`#block-${clientId}`);
    const HTML = `<div class="h5ap_standard_player">
                    <audio download="false" playsinline>
                      <source src='${source}' type="audio/mp3"></source>
                    </audio>
                  </div>`;

    jQuery(audioPlayer).find(`.skin_${skin.toLowerCase()}`).html(HTML);

    const newControls = Object.keys(controls).filter((item) => (controls[item] ? item : false));

    H5AP_Obj.audioPlayer(audioPlayer, {
      controls: newControls,
      title,
      seekTime,
      primaryColor,
      repeat,
      poster,
      source,
      artist,
      skin: skin.toLowerCase(),
      fusionDownload: download,
      color,
      bgColor,
    });
  }, [attributes]);

  return (
    <Fragment>
      <Style {...props} />
      {/* <BPLSDK setAttributes={setAttributes} /> */}
      <Settings props={props} isPremium={isPremium} />
      <div className={`skin_${skin.toLowerCase()} h5ap_player align${align}`} id={uniqueId}>
        <div className="h5ap_standard_player">
          <audio download="false" playsinline>
            <source src={source} type="audio/mp3"></source>
          </audio>
        </div>
      </div>
    </Fragment>
  );
};

export default Edit;
